<template>
  <v-card 
    style="width: 100%"
    class="mx-3"
  >
    <v-toolbar
      flat
    >
      <v-text-field 
        v-if="editionMode"
        v-model="title" 
        :placeholder="$t('messages.label.titlePlaceholder')" 
        persistent-placeholder 
        :hint="$t('messages.label.titleHint')"
      ></v-text-field>
      <v-card-title
        v-else 
      >
        {{ title }}
      </v-card-title>
      <v-spacer></v-spacer>
      <v-menu 
        v-if="editionMode"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            {{ localizedMessage.language }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="language in remainingLanguages"
            :key="language"
          >
            <v-list-item-title @click="setLanguage(language)">{{ language }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-chip
        v-else
        color="primary"
      >{{ localizedMessage.language }}
      </v-chip>
      <v-btn
        v-if="editionMode"
        icon
        @click="deleteLocalizedMessage"
      >
        <v-icon>{{ localizedMessage.existing ? 'mdi-delete' : 'mdi-close' }}</v-icon>
      </v-btn>
    </v-toolbar>
    <div>
      <ckeditor v-if="editionMode" :editor="editor" v-model="body" :config="editorConfig"></ckeditor>
      <v-card-text v-else v-html="body"></v-card-text>
    </div>    
  </v-card>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
  props: ["editionMode", "localizedMessageIdx", "localizedMessage", "remainingLanguages", "jsonpath"],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        // configuration of the wysiwyg editor.
      }
    };
  },
  mounted() {
  },
  computed: {
    title: {
      get() {
        const title = this.localizedMessage.title;
        return title ? title : ""
      },
      set(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { title: value }}})
      }
    },
    body: {
      get() {
        const body = this.localizedMessage.body;
        return body ? body : ""
      },
      set(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { body: value }}})
      }
    },
  },
  methods: {
    setLanguage(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { language: value }}})
    },
    deleteLocalizedMessage() {
      this.$emit("delete", this.localizedMessageIdx)
    }
  },

}
</script>